// ========================================================================
// This file is auto-generated by the `yarn naptime:types` script
// ========================================================================
import NaptimeResource from 'bundles/naptimejs/resources/NaptimeResource';

// ========================================================================
// Definitions for resource data types
// ========================================================================

export type EnterpriseContractTerminatedReason =
  | 'CONTRACT_END_DATE'
  | 'FREE_TRIAL_EXPIRED'
  | 'FREE_TRIAL_CONVERSION_FAILURE'
  | 'INITIAL_PAYMENT_FAILED'
  | 'MISSING_PAYMENT'
  | 'RENEWAL_GRACE_PERIOD_EXCEEDED'
  | 'REFUNDED'
  | 'MIGRATED'
  | 'DOWNGRADED'
  | 'INITIAL_INVOICE_VOIDED';

export type EnterpriseContractBillingType = 'NONE' | 'INVOICE' | 'QUARTERLY' | 'ONE_TIME';

export type EnterpriseContractType = 'STANDARD' | 'SELF_SERVE';

export type EnterpriseContractPriceMappingName = 'ORIGINAL_RELEASE_MAPPINGS' | 'ONE_COURSE_VALUE_INCREASE_MAPPINGS';

export interface SelfServeEnterpriseContractProperties {
  paymentWalletId: number;
  priceMappingName?: EnterpriseContractPriceMappingName | null;
}

export interface EnterpriseContractPropertiesSelfServeProperties {
  typeName: 'selfServeProperties';
  definition: SelfServeEnterpriseContractProperties;
}

export interface InvoiceBilledContractProperties {
  userId: number;
  customerId: string;
  paymentProcessorId: string;
}

export interface EnterpriseContractPropertiesInvoiceBilledContractProperties {
  typeName: 'invoiceBilledContractProperties';
  definition: InvoiceBilledContractProperties;
}

export type EnterpriseContractProperties =
  | EnterpriseContractPropertiesSelfServeProperties
  | EnterpriseContractPropertiesInvoiceBilledContractProperties;

export type EnterpriseContractPropertiesTypeName = 'selfServeProperties' | 'invoiceBilledContractProperties';

export type EnterpriseContractLimitType =
  | 'USER_LICENSE'
  | 'ENROLLMENT_CAP'
  | 'NO_LIMIT'
  | 'USER_LICENSE_WITH_ENROLLMENT_CAP';

export type EnterpriseContractBillingSystemType =
  | 'AUTOMATED_TRANSACTION_PAYMENT'
  | 'OFF_PLATFORM_INVOICE'
  | 'AUTOMATED_INVOICE'
  | 'NON_BILLABLE';

export type EnterpriseContractTermTag = 'C4T_FREE_TRIAL';

export interface EnterpriseContractTerm {
  id: string;
  enterpriseContractId: string;
  promotionId: number;
  startsAt: number;
  endsAt?: number | null;
  writtenAt: number;
  fxRateId?: number | null;
  unitPrice?: string | null;
  termTag?: EnterpriseContractTermTag | null;
}

export interface EnterpriseContractLimits {
  userLimit?: number | null;
  coursesPerUserLimit?: number | null;
  enrollmentCapLimit?: number | null;
}

export type EnterpriseContractState = 'CREATED' | 'ACTIVE' | 'PAUSED' | 'TERMINATED' | 'EXPIRED';

export interface EnterpriseContractsV1 {
  id: string;
  enterpriseContractId: string;
  thirdPartyOrganizationId: string;
  startsAt?: number | null;
  endsAt?: number | null;
  endedAt?: number | null;
  terminationReason?: EnterpriseContractTerminatedReason | null;
  billingType: EnterpriseContractBillingType;
  contractType: EnterpriseContractType;
  promotionId: number;
  properties?: EnterpriseContractProperties | null;
  countryIsoCode?: string | null;
  currencyCode?: string | null;
  planId: number;
  limitType: EnterpriseContractLimitType;
  name?: string | null;
  durationInMonths?: number | null;
  isPaused: boolean;
  createdAt: number;
  salesforceCaseNumber?: string | null;
  billingSystemType: EnterpriseContractBillingSystemType;
  isReal: boolean;
  hardPausedAt?: number | null;
  terms: Array<EnterpriseContractTerm>;
  limits: EnterpriseContractLimits;
  value: string;
  contractState: EnterpriseContractState;
}

// ========================================================================
// Definitions for naptime-link
// ========================================================================

export interface EnterpriseContractsV1Connection {
  elements: Array<EnterpriseContractsV1> | null;
}

// ========================================================================
// Definitions for naptime-link queries
// ========================================================================

export interface EnterpriseContractsV1ByThirdPartyOrganizationQuery {
  EnterpriseContractsV1: {
    byThirdPartyOrganization: EnterpriseContractsV1Connection | null;
  } | null;
}

export interface EnterpriseContractsV1ByThirdPartyOrganizationQueryVariables {
  id: string;
  includeExpired?: string | null;
  includes?: string | null;
}

export interface EnterpriseContractsV1ByThirdPartyOrganizationAndContractTypeQuery {
  EnterpriseContractsV1: {
    byThirdPartyOrganizationAndContractType: EnterpriseContractsV1Connection | null;
  } | null;
}

export interface EnterpriseContractsV1ByThirdPartyOrganizationAndContractTypeQueryVariables {
  id: string;
  contractType: string;
  includes?: string | null;
}

export interface EnterpriseContractsV1DeleteQuery {
  EnterpriseContractsV1: {
    delete: EnterpriseContractsV1Connection | null;
  } | null;
}

export interface EnterpriseContractsV1DeleteQueryVariables {
  id: string;
  includes?: string | null;
}

export interface EnterpriseContractsV1GetQuery {
  EnterpriseContractsV1: {
    get: EnterpriseContractsV1Connection | null;
  } | null;
}

export interface EnterpriseContractsV1GetQueryVariables {
  id: string;
  includes?: string | null;
}

export interface EnterpriseContractsV1GetContractsByCurrentTermEndBetweenRangeQuery {
  EnterpriseContractsV1: {
    getContractsByCurrentTermEndBetweenRange: EnterpriseContractsV1Connection | null;
  } | null;
}

export interface EnterpriseContractsV1GetContractsByCurrentTermEndBetweenRangeQueryVariables {
  from: string;
  to: string;
  billingSystemType?: string | null;
  includes?: string | null;
}

export interface EnterpriseContractsV1GetNonTerminatedFreeTrialContractsQuery {
  EnterpriseContractsV1: {
    getNonTerminatedFreeTrialContracts: EnterpriseContractsV1Connection | null;
  } | null;
}

export interface EnterpriseContractsV1GetNonTerminatedFreeTrialContractsQueryVariables {
  includes?: string | null;
}

export interface EnterpriseContractsV1MultiGetQuery {
  EnterpriseContractsV1: {
    multiGet: EnterpriseContractsV1Connection | null;
  } | null;
}

export interface EnterpriseContractsV1MultiGetQueryVariables {
  ids: string;
  includes?: string | null;
}

// ========================================================================
// Definitions for naptime-link mutations
// ========================================================================

export interface EnterpriseContractsV1ActivateMutation {
  EnterpriseContractsV1: {
    activate: EnterpriseContractsV1Connection | null;
  } | null;
}

export interface EnterpriseContractsV1ActivateMutationVariables {
  includes?: string | null;
}

export interface EnterpriseContractsV1CreateEnterpriseContractMutation {
  EnterpriseContractsV1: {
    createEnterpriseContract: EnterpriseContractsV1Connection | null;
  } | null;
}

export interface EnterpriseContractsV1CreateEnterpriseContractMutationVariables {
  includes?: string | null;
}

export interface EnterpriseContractsV1DebugTransitionStateMutation {
  EnterpriseContractsV1: {
    debugTransitionState: EnterpriseContractsV1Connection | null;
  } | null;
}

export interface EnterpriseContractsV1DebugTransitionStateMutationVariables {
  id: string;
  includes?: string | null;
}

export interface EnterpriseContractsV1DirectCreateWESContractMutation {
  EnterpriseContractsV1: {
    directCreateWESContract: EnterpriseContractsV1Connection | null;
  } | null;
}

export interface EnterpriseContractsV1DirectCreateWESContractMutationVariables {
  includes?: string | null;
}

export interface EnterpriseContractsV1DowngradeMutation {
  EnterpriseContractsV1: {
    downgrade: EnterpriseContractsV1Connection | null;
  } | null;
}

export interface EnterpriseContractsV1DowngradeMutationVariables {
  id: string;
  sendMembershipDeletionNotification?: string | null;
  includes?: string | null;
}

export interface EnterpriseContractsV1InitializeContractStartAndGetMutation {
  EnterpriseContractsV1: {
    initializeContractStartAndGet: EnterpriseContractsV1Connection | null;
  } | null;
}

export interface EnterpriseContractsV1InitializeContractStartAndGetMutationVariables {
  id: string;
  includes?: string | null;
}

export interface EnterpriseContractsV1PauseMutation {
  EnterpriseContractsV1: {
    pause: EnterpriseContractsV1Connection | null;
  } | null;
}

export interface EnterpriseContractsV1PauseMutationVariables {
  includes?: string | null;
}

export interface EnterpriseContractsV1RevokeContractMutation {
  EnterpriseContractsV1: {
    revokeContract: EnterpriseContractsV1Connection | null;
  } | null;
}

export interface EnterpriseContractsV1RevokeContractMutationVariables {
  id: string;
  reason?: string | null;
  revokeTime?: string | null;
  includes?: string | null;
}

export interface EnterpriseContractsV1RevokeWESContractMutation {
  EnterpriseContractsV1: {
    revokeWESContract: EnterpriseContractsV1Connection | null;
  } | null;
}

export interface EnterpriseContractsV1RevokeWESContractMutationVariables {
  id: string;
  reason?: string | null;
  includes?: string | null;
}

export interface EnterpriseContractsV1UpdateContractBillingTypeMutation {
  EnterpriseContractsV1: {
    updateContractBillingType: EnterpriseContractsV1Connection | null;
  } | null;
}

export interface EnterpriseContractsV1UpdateContractBillingTypeMutationVariables {
  id: string;
  billingType: string;
  includes?: string | null;
}

export interface EnterpriseContractsV1UpdateContractEndsAtMutation {
  EnterpriseContractsV1: {
    updateContractEndsAt: EnterpriseContractsV1Connection | null;
  } | null;
}

export interface EnterpriseContractsV1UpdateContractEndsAtMutationVariables {
  id: string;
  endDate: string;
  includes?: string | null;
}

export interface EnterpriseContractsV1UpdateContractLimitsV3Mutation {
  EnterpriseContractsV1: {
    updateContractLimitsV3: EnterpriseContractsV1Connection | null;
  } | null;
}

export interface EnterpriseContractsV1UpdateContractLimitsV3MutationVariables {
  contractId: string;
  includes?: string | null;
}

export interface EnterpriseContractsV1UpdateContractNameMutation {
  EnterpriseContractsV1: {
    updateContractName: EnterpriseContractsV1Connection | null;
  } | null;
}

export interface EnterpriseContractsV1UpdateContractNameMutationVariables {
  id: string;
  name: string;
  includes?: string | null;
}

export interface EnterpriseContractsV1UpdateEndsAtMutation {
  EnterpriseContractsV1: {
    updateEndsAt: EnterpriseContractsV1Connection | null;
  } | null;
}

export interface EnterpriseContractsV1UpdateEndsAtMutationVariables {
  contractId: string;
  endsAt?: string | null;
  includes?: string | null;
}

export interface EnterpriseContractsV1UpdateIsRealMutation {
  EnterpriseContractsV1: {
    updateIsReal: EnterpriseContractsV1Connection | null;
  } | null;
}

export interface EnterpriseContractsV1UpdateIsRealMutationVariables {
  id: string;
  isReal: string;
  skipValidation?: string | null;
  notes?: string | null;
  includes?: string | null;
}

export interface EnterpriseContractsV1UpdatePlanIdMutation {
  EnterpriseContractsV1: {
    updatePlanId: EnterpriseContractsV1Connection | null;
  } | null;
}

export interface EnterpriseContractsV1UpdatePlanIdMutationVariables {
  contractId: string;
  planId: string;
  includes?: string | null;
}

export interface EnterpriseContractsV1UpdateStandardContractBillingTypeMutation {
  EnterpriseContractsV1: {
    updateStandardContractBillingType: EnterpriseContractsV1Connection | null;
  } | null;
}

export interface EnterpriseContractsV1UpdateStandardContractBillingTypeMutationVariables {
  id: string;
  billingType: string;
  includes?: string | null;
}

export interface EnterpriseContractsV1UpdateStartsAtMutation {
  EnterpriseContractsV1: {
    updateStartsAt: EnterpriseContractsV1Connection | null;
  } | null;
}

export interface EnterpriseContractsV1UpdateStartsAtMutationVariables {
  contractId: string;
  startsAt: string;
  includes?: string | null;
}

export interface EnterpriseContractsV1UpdateWalletIdMutation {
  EnterpriseContractsV1: {
    updateWalletId: EnterpriseContractsV1Connection | null;
  } | null;
}

export interface EnterpriseContractsV1UpdateWalletIdMutationVariables {
  id: string;
  walletId: string;
  includes?: string | null;
}

// ========================================================================
// Definitions for naptime-js
// ========================================================================

// Recursively applies Partial<T> to supported culling by the `fields` param.
type PartialConstruction<T> = {
  [TKey in keyof T]?: T[TKey] extends Array<infer TElement>
  ? Array<PartialConstruction<TElement>>
  : T[TKey] extends object
  ? PartialConstruction<T[TKey]>
  : T[TKey];
};

export class EnterpriseContractsV1NaptimeResource extends NaptimeResource {
  static RESOURCE_NAME = 'enterpriseContracts.v1' as const;

  id!: string;

  enterpriseContractId!: string;

  thirdPartyOrganizationId!: string;

  startsAt?: number | null;

  endsAt?: number | null;

  endedAt?: number | null;

  terminationReason?: EnterpriseContractTerminatedReason | null;

  billingType!: EnterpriseContractBillingType;

  contractType!: EnterpriseContractType;

  promotionId!: number;

  properties?: EnterpriseContractProperties | null;

  countryIsoCode?: string | null;

  currencyCode?: string | null;

  planId!: number;

  limitType!: EnterpriseContractLimitType;

  name?: string | null;

  durationInMonths?: number | null;

  isPaused!: boolean;

  createdAt!: number;

  salesforceCaseNumber?: string | null;

  billingSystemType!: EnterpriseContractBillingSystemType;

  isReal!: boolean;

  hardPausedAt?: number | null;

  terms!: Array<EnterpriseContractTerm | null>;

  limits!: EnterpriseContractLimits;

  value!: string;

  contractState!: EnterpriseContractState;

  // Intentionally "useless" to supply params type
  // eslint-disable-next-line @typescript-eslint/no-useless-constructor
  constructor(params: PartialConstruction<EnterpriseContractsV1>) {
    super(params);
  }
}
